const findInObject = (obj, key, value) => {
  let foundObj
  JSON.stringify(obj, (_, nestedValue) => {
    if (nestedValue && nestedValue[key] === value) {
      foundObj = nestedValue
    }
    return nestedValue
  })
  return foundObj
}

const removeEmptyKeys = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== ''))

export { findInObject, removeEmptyKeys }
